  import  { React,useState , useEffect} from "react";
  import { HashLink as Link } from "react-router-hash-link";
  import logo from "./../../assets/images/logo.svg";
  import burgerMenu from "./../../assets/images/burgerMenu.svg";


  const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
      setMenuOpen(!menuOpen);
      console.log(menuOpen);
    };

    useEffect(() => {
      if (menuOpen) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
      // Nettoyage à la fermeture du composant
      return () => {
        document.body.classList.remove("no-scroll");
      };
    }, [menuOpen]);

    return (
      <header className="Header-container" id="acceuil">
        <nav className="Nav-container">
            <li className="close" onClick={toggleMenu}>
              <img src={burgerMenu} alt="arrow" className="burger-icon"/>
            </li>
            <li className="close" onClick={toggleMenu}>
              <img src={logo} alt="logo" className="logoMobile"/>
            </li>
          <ul className={menuOpen ? "fullscreen-nav active" : "fullscreen-nav hide"}>
            <li className={menuOpen ? "logo active" : "logo hide"} onClick={toggleMenu}>
              <img src={logo} alt="logo" />
            </li> 
            <li className={menuOpen ? "firstli active" : "firstli hide"} onClick={toggleMenu}>
              <Link to="#acceuil">Accueil</Link>
            </li>
            <li className={menuOpen ? "active" : "hide"} onClick={toggleMenu}>
              <Link to="#services">Services</Link>
            </li>
            <li className={menuOpen ? "active" : "hide"} onClick={toggleMenu}>
              <Link to="#about">À propos</Link>
            </li>
            <li className={menuOpen ? "contact active" : "contact hide"} onClick={toggleMenu}>
              <Link to="#contact">Contact</Link>
            </li>
          </ul>
        </nav>
        <article className="Title-container">
          <p>
            Gagnez du temps, de la sérénité et repartez avec un sourire en prime !
          </p>
          <h1>
            VOUS <br className="brResponsive"/><span className="blue">COMPTEZ</span><br className="brResponsive"/> SUR NOUS<span className="question-mark"> ?</span>
            <br /> NOUS COMPTONS <span className="blue">POUR VOUS</span> !
          </h1>
          <Link to="#contact" className="btn btn-header">
             Découvrez nos services <svg xmlns="http://www.w3.org/2000/svg" className="arrow-icon white" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
          </Link>
        </article>
        <aside className="Article-container">
          <ul className="Article-list">
            <li>
              SIMPLICITÉ <strong>: <br />
            ON PARLE CHIFFRES
              <br /> SANS JARGON.</strong>
            </li>
            <li>
              PROXIMITÉ <strong>: <br />
              CHAQUE CLIENT COMPTE
              <br /> (ET ON NE DIT PAS ÇA POUR LA RIME).</strong>
            </li>
            <li>
              INNOVATION <strong>: <br />
              DES OUTILS MODERNES QUI
              <br /> S’ADAPTENT À VOS BESOINS.</strong>
            </li>
            <li>
              BONNE HUMEUR <strong>: <br />
              SÉRIEUX SUR LE FOND,
              <br /> COOL SUR LA FORME.</strong>
            </li>
          </ul>
        </aside>
      </header>
    );
  };

  export default Header;